import styled from '@emotion/styled'

import { NativeLink, palette, spacing, Text, typography } from 'main/ui'

export const PricingContainer = styled.div`
  background-color: ${palette.white};
  border-radius: 5px;
  margin-bottom: ${spacing.majorScale(3)}px;
  padding: ${spacing.majorScale(2)}px ${spacing.majorScale(2)}px 0;
`

export const EmptyPricingContainer = styled.div`
  background-color: ${palette.transparent};
  border-radius: 5px;
  margin-bottom: ${spacing.majorScale(3)}px;
  padding: ${spacing.majorScale(7)}px ${spacing.majorScale(7)}px 0;
`

export const PricingText = styled(Text)`
  font-weight: ${typography.fontWeight.bold};
  font-size: ${typography.fontSize.title.section};
`

export const PricingSubText = styled(Text)`
  font-weight: ${typography.fontWeight.light};
  font-size: ${typography.fontSize.text};
  color: ${palette.slate};
`

export const PricingSubTextContainer = styled.div`
  margin-top: ${spacing.majorScale(1)}px;
`

export const LinkContainer = styled.div`
  margin-top: ${spacing.majorScale(1)}px;
`

export const StyledNativeLink = styled(NativeLink)`
  font-weight: ${typography.fontWeight.bold};
`
